import React from "react";
import "./Management.scss";
import SideMenu from "../../components/SideMenu/SideMenu";
import * as conf from "../../../config";
import { useStoreState } from "easy-peasy";
import person from "../../images/person.svg";

function isEven(n) {
  return n % 2 == 0;
}

const Management = () => {
  const manager = useStoreState((state) => state.manager.managers);
  return (
    <div className="managementMain">
      <div className="navLine"></div>
      <div className="container">
        <SideMenu />
        <div className="main">
          <div className="header">Руководство</div>
          <div className="cardsContainer">
            {manager.map((el, index) => (
              <div
                className={isEven(index) ? "card" : "card reverse"}
                key={el._id}
              >
                <img
                  className="pic"
                  src={el.avatar ? conf.API_HOST + el.avatar.url : person}
                  alt="avatar"
                />
                <div className="text">
                  <h3>{el.position}</h3>
                  <span>{el.name}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

Management.getInitialProps = async (props) => {
  if (props.isServer) {
    await props.store.dispatch.manager.getManag({
      sort: { order: "ASC" },
    });
  } else {
    const store = require("../../client");
    if (store.default.getState().manager.managers.length < 1) {
      await store.default.dispatch.manager.getManag({
        sort: { order: "ASC" },
      });
    }
  }
  return { whatever: "stuff" };
};

export default Management;
